var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex justify-content-center" }, [
    _c(
      "div",
      { staticClass: "general-wrap" },
      [
        _c("div", { staticClass: "d-flex justify-content-end" }, [
          _c(
            "button",
            {
              staticClass: "button-blue button-update",
              on: { click: _vm.updateApp }
            },
            [_vm._v("\n        Update\n      ")]
          )
        ]),
        _vm._v(" "),
        _vm.isLoading
          ? _c("skeleton-general-tab")
          : _c("div", { staticClass: "card-content card-general" }, [
              _c("div", [
                _c("div", { staticClass: "config-section d-flex mb-10px" }, [
                  _c(
                    "div",
                    {
                      staticClass: "preview-icon",
                      class: {
                        "error-icon": _vm.$v.application.icon_url.$error
                      }
                    },
                    [
                      _vm.application.icon_url
                        ? _c("img", {
                            attrs: { src: _vm.application.icon_url }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("input", {
                        ref: "iconUpload",
                        staticClass: "upload-photo",
                        attrs: { type: "file" },
                        on: {
                          change: function($event) {
                            _vm.handleIconUpload($event)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("p", { staticClass: "title-config" }, [
                      _vm._v("Application Icon")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-config" }, [
                      _vm._v(
                        "\n              Icon must be minimum size 1024 x 1024px and .png format.\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "upload-btn",
                        on: {
                          click: function($event) {
                            _vm.$refs.iconUpload.click()
                          }
                        }
                      },
                      [_vm._v("\n              Upload\n            ")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "config-section" },
                  [
                    _c("div", { staticClass: "mb-2" }, [
                      _c("p", { staticClass: "title-config" }, [
                        _vm._v("General Information")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc-config" }, [
                        _vm._v(
                          "\n              Information to describe the application\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-1",
                        class: {
                          "error-input": _vm.$v.application.app_name.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Application Name ")]),
                        _vm._v(" "),
                        _c("j-input", {
                          attrs: {
                            "error-required": false,
                            placeholder: "Enter application name"
                          },
                          model: {
                            value: _vm.application.app_name,
                            callback: function($$v) {
                              _vm.$set(_vm.application, "app_name", $$v)
                            },
                            expression: "application.app_name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.typeMode === "hyperlink"
                      ? _c(
                          "b-form-group",
                          {
                            staticClass: "mb-1",
                            class: {
                              "error-input": _vm.$v.application.app_url.$error
                            }
                          },
                          [
                            _c("label", [_vm._v(" URL ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: {
                                "error-required": false,
                                placeholder: "Enter url"
                              },
                              model: {
                                value: _vm.application.app_url,
                                callback: function($$v) {
                                  _vm.$set(_vm.application, "app_url", $$v)
                                },
                                expression: "application.app_url"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        staticClass: "mb-1",
                        class: {
                          "error-input": _vm.$v.application.desc_name.$error
                        }
                      },
                      [
                        _c("label", [_vm._v(" Description ")]),
                        _vm._v(" "),
                        _c("j-textarea", {
                          attrs: {
                            "error-required": false,
                            placeholder: "Enter application description"
                          },
                          model: {
                            value: _vm.application.desc_name,
                            callback: function($$v) {
                              _vm.$set(_vm.application, "desc_name", $$v)
                            },
                            expression: "application.desc_name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      [
                        _c("label", [_vm._v(" Group Application ")]),
                        _vm._v(" "),
                        _c("j-single-select", {
                          attrs: {
                            options: _vm.groupOptions,
                            "error-required": false,
                            placeholder: "Select Group",
                            "value-format": "object"
                          },
                          model: {
                            value: _vm.selectedGroup,
                            callback: function($$v) {
                              _vm.selectedGroup = $$v
                            },
                            expression: "selectedGroup"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.typeMode === "hyperlink"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center mt-3"
                          },
                          [
                            _c("label", [
                              _vm._v(" Open Hyperlink in App Browser (Mobile) ")
                            ]),
                            _vm._v(" "),
                            _c("j-switch", {
                              model: {
                                value:
                                  _vm.application.open_hyperlink_in_app_browser,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.application,
                                    "open_hyperlink_in_app_browser",
                                    $$v
                                  )
                                },
                                expression:
                                  "application.open_hyperlink_in_app_browser"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.typeMode === "hyperlink"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center mt-3"
                          },
                          [
                            _c("label", [_vm._v(" Use Token ")]),
                            _vm._v(" "),
                            _c("j-switch", {
                              model: {
                                value: _vm.application.use_token,
                                callback: function($$v) {
                                  _vm.$set(_vm.application, "use_token", $$v)
                                },
                                expression: "application.use_token"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.application.is_offline_mode
                      ? _c("div", { staticClass: "local-storage mt-3" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/logo/offline-mode.png"),
                              height: "16"
                            }
                          }),
                          _vm._v(
                            "\n            Local Storage Support\n          "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "config-section d-flex justify-content-between align-items-center mb-10px"
                  },
                  [
                    _c("div", [
                      _c("p", { staticClass: "title-config" }, [
                        _vm._v("Search Menu")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc-config" }, [
                        _vm._v(
                          "\n              A search bar or search box in order to look up menu or page\n            "
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.application.search_menu,
                        callback: function($$v) {
                          _vm.$set(_vm.application, "search_menu", $$v)
                        },
                        expression: "application.search_menu"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "config-section" }, [
                  _c("div", { staticClass: "mb-2" }, [
                    _c("p", { staticClass: "title-config" }, [
                      _vm._v("Display Mode")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc-config" }, [
                      _vm._v(
                        "\n              Select the device that will be used to display this application\n            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex align-items-center" },
                    _vm._l(_vm.listDisplayOptions, function(option) {
                      return _c(
                        "div",
                        {
                          key: option.id,
                          staticClass: "btn-option",
                          class: {
                            active: _vm.displayModeSelected.includes(option.id)
                          },
                          on: {
                            click: function($event) {
                              _vm.handleDisplayMode(option.id)
                            }
                          }
                        },
                        [
                          !_vm.displayModeSelected.includes(option.id)
                            ? _c("div", { staticClass: "circle-checkbox" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.displayModeSelected.includes(option.id)
                            ? _c("img", {
                                staticClass: "checked",
                                attrs: {
                                  src: require("@/assets/new-form-ui/icon-active/check-circle-active.svg")
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "icon-btn",
                            attrs: {
                              src: require("@/assets/form-ui/" +
                                option.id +
                                (_vm.displayModeSelected.includes(option.id)
                                  ? "-active"
                                  : "") +
                                ".svg")
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(option.text))])
                        ]
                      )
                    })
                  )
                ])
              ])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-209534a7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-209534a7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/jGeneralTab.vue
// module id = null
// module chunks = 